import { render, staticRenderFns } from "./VCheckbox.vue?vue&type=template&id=6c76ba44&scoped=true"
import script from "./VCheckbox.vue?vue&type=script&lang=js"
export * from "./VCheckbox.vue?vue&type=script&lang=js"
import style0 from "./VCheckbox.vue?vue&type=style&index=0&id=6c76ba44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c76ba44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
